import './styles.scss';
import * as $ from 'jquery';

export default function registerAccordions() {
  // =============================================================================
  // JQUERY FUNCTION DEFINITIONS
  // =============================================================================

  /**
   * Returns the parent .accordion element based on the given element.
   */
  $.fn.findAccordionParent = function () {
    if (!$(this[0]).hasClass('accordion')) {
      return $(this[0]).closest('.accordion');
    } else {
      return $(this[0]);
    }
  };

  /**
   * Counts the total number of accordion sections within an accordion group.
   */
  $.fn.countTotalItems = function () {
    return $(this[0]).findAccordionParent().find('.accordion-section').length;
  };

  /**
   * Counts the number of expanded accordion sections within an accordion group.
   */
  $.fn.countExpandedItems = function () {
    return $(this[0]).findAccordionParent().find("[aria-expanded='true']")
      .length;
  };

  /**
   * Toggles the visibility of the [+ Expand] and [- Collapse] buttons based on
   * the number of expanded accordion sections.
   */
  $.fn.toggleExpandCollapseButtons = function () {
    const $target = $(this[0]).findAccordionParent();
    const totalItems = $target.countTotalItems();
    const expandedItems = $target.countExpandedItems();

    if (expandedItems === 0) {
      $target.find('.expand-all').show();
      $target.find('.collapse-all').hide();
    } else if (expandedItems < totalItems) {
      $target.find('.expand-all').show();
      $target.find('.collapse-all').show();
    } else if (expandedItems === totalItems) {
      $target.find('.expand-all').hide();
      $target.find('.collapse-all').show();
    }

    return this;
  };

  // =============================================================================
  // MAIN LOGIC
  // =============================================================================

  // Assign each .accordion-section to a group, based on their adjacent elements.

  let accordionGroupIndex = 0;

  $('.accordion-section').each((index, element) => {
    const $prevElem = $(element).prev();
    if (!$prevElem || !$prevElem.hasClass('accordion-section')) {
      accordionGroupIndex += 1;
    }
    $(element).attr('data-accordion-group', accordionGroupIndex);
  });

  // Wrap each according group within a div.accordion element. If an accordion
  // group has more than one section, then set data-use-expand-collapse-buttons
  // to `true`.

  for (let agi = 1; agi <= accordionGroupIndex; agi++) {
    const $groupItems = $(`.accordion-section[data-accordion-group='${agi}']`);
    const useExpandCollapse = $groupItems.length > 1 ? 'true' : 'false';
    $groupItems.wrapAll(
      `<div
        class='accordion'
        data-use-expand-collapse-buttons="${useExpandCollapse}"
      />`
    );
  }

  // For each accordion group where data-use-expand-collapse-buttons is `true`,
  // prepend the [+ Expand] and [- Collapse] buttons and toggle their visibility
  // based on the number of already expanded sections.

  $(".accordion[data-use-expand-collapse-buttons='true']").each(function () {
    $(this)
      .prepend(
        `<span class="expand-collapse-buttons  d-flex justify-content-end">
          <button
            class="expand-all  btn btn-link px-2"
            data-action="show"
            style="display: none;">&plus; Expand all</button>
          <button
            class="collapse-all  btn btn-link px-2"
            data-action="hide"
            style="display: none;">&ndash; Collapse all</button>
        </span>`
      )
      .toggleExpandCollapseButtons();
  });

  // =============================================================================
  // EVENT HANDLERS
  // =============================================================================

  /**
   * Handle the click event for the [+ Expand] and [- Collapse] buttons.
   */
  $(document).on(
    'click',
    '.accordion .expand-collapse-buttons button',
    function () {
      $(this)
        .closest('.accordion')
        .find('.accordion-body')
        .collapse($(this).attr('data-action'));
    }
  );

  /**
   * Hook onto the `hidden.bs.collapse` and `shown.bs.collapse` events and toggle
   * the visibility of the [+ Expand] and [- Collapse] buttons accordingly.
   */
  $('.accordion-body').on('hidden.bs.collapse shown.bs.collapse', function () {
    $(this).toggleExpandCollapseButtons();
  });
}
